import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./Layout";
import { IndexPage } from "./pages/IndexPage";
import { SettingsPage } from "./pages/SettingsPage";
import { WalletPage } from "./pages/WalletPage";
import { PlayResponsiblyPage } from "./pages/PlayResponsiblyPage";
import { AboutUsPage } from "./pages/AboutUsPage";
import { GamePage } from "./pages/GamePage";
import { GotAPromoPage } from "./pages/GotAPromoPage";
import { CreateAccountPage } from "./pages/CreateAccountPage";
import { VerifyAccountPage } from "./pages/VerifyAccountPage";
import { PrizeWinningsPage } from "./pages/PrizeWinningsPage";
import { ModalProvider } from "./context/ModalProvider";
import { InfoPage } from "./pages/InfoPage";
import { LoginPage } from "./pages/LoginPage";
import { JackpotPage } from "./pages/JackpotPage";
import { ViewTransitionProvider } from "./context/ViewTransitionProvider";
// import { LoadingComponent } from "./components/LoadingComponent";
import { SkillScratchUnavailablePage } from "./pages/SkillScratchUnavailablePage";
import { StaticLoading } from "./pages/StaticLoading";


const createRoutesA = () => [
  {
    element:
    <ViewTransitionProvider>
      <ModalProvider>
        <Layout />
      </ModalProvider>
    </ViewTransitionProvider>,
    children: [
      {
        path: "/",
        element: (
          <StaticLoading />
        ),
      },
      {
        path: "/home",
        element: (
          <PrizeWinningsPage />
        ),
      },
      {
        path: "onboarding/page0",
        element: (
          <InfoPage />
        ),
      },
      {
        path: "onboarding/page1",
        element: (
          <GotAPromoPage />
        ),
      },
      {
        path: "onboarding/page2",
        element: (
          <CreateAccountPage />
        ),
      },
      {
        path: "onboarding/page3",
        element: (
          <VerifyAccountPage />
        ),
      },
      // {
      //   path: "onboarding/page4",
      //   element: (
      //     <TransitionWrapper>
            
      //     </TransitionWrapper>
      //   ),
      // },
      {
        path: "/settings",
        element: (
          <SettingsPage />
        ),
      },
      {
        path: "/wallet",
        element: (
          <WalletPage />
        ),
      },
      {
        path: "/play-responsibly",
        element: (
          <PlayResponsiblyPage />
        ),
      },
      {
        path: "/about-us",
        element: (
          <AboutUsPage />
        ),
      },
      {
        path: "/game",
        element: (
          <GamePage />
        ),
      },
      {
        path: "/index",
        element: (
          <IndexPage />
        ),
      },
      {
        path: "/login",
        element: (
          <LoginPage />
        ),
      },
      {
        path: "/jackpot",
        element: (
          <JackpotPage />
        ),
      },
      // {
      //   path: "/apple-pay",
      //   element: (
      //     <ApplePayPage />
      //   ),
      // },
      {
        path: "/skillscratch-unavailable",
        element: <SkillScratchUnavailablePage />
      },
    ]
  }
];

const getBasePath = () => {
  const pathname = window.location.pathname;
  if (pathname.startsWith('/v1')) {
    return '/v1';
  }
  return '/';
};

const getRoutes = () => {
  return createRoutesA();
};

export const router = createBrowserRouter(
  getRoutes(),
  {
    basename: getBasePath(),
  }
);